(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('AgentSupplierContractCustom', AgentSupplierContractCustom);

    AgentSupplierContractCustom.$inject = ['$resource', 'DateUtils'];

    function AgentSupplierContractCustom($resource) {
        var getCurrentAgentSuppliers = function () {
            var resourceUrl = 'api/get-current-agent-suppliers';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        }

        var saveAgentSuppliersAccess = function () {
            var resourceUrl = 'api/save-agent-supplier-access';
            return $resource(resourceUrl, {}, {}
            );
        }

        var getAgentSupplierWithAllAccessById = function (contractId) {

            var resourceUrl = 'api/get-agent-supplier-with-all-access-by-id?contractId=' + contractId;
            return $resource(resourceUrl, {}, {
                    'get': {
                        method: 'GET',
                        transformResponse: function (data) {
                            if (data) {
                                data = angular.fromJson(data);
                            }
                            return data;
                        }
                    }
                }
            );
        }

        return {
            getCurrentAgentSuppliers: getCurrentAgentSuppliers,
            saveAgentSuppliersAccess: saveAgentSuppliersAccess,
            getAgentSupplierWithAllAccessById: getAgentSupplierWithAllAccessById

        };
    }
})();
